import { useGetDebtor } from 'api';
import { computeDebtorBalance } from 'app/Private/Clients/Detail/BalanceTab/ComputeDebtorBalance';
import { isNullish } from 'remeda';
import { useLoadDebtorBalance } from 'shared/hooks/use-load-debtor-balance';
import { treatClient } from 'shared/serializer';

export const useClientHoverCardData = (debtorId: string) => {
  const {
    data: debtorDetailsResponse,
    isLoading: isDebtorLoading,
    isError: isDebtorError,
  } = useGetDebtor(debtorId);
  const { debtorBalance, isDebtorBalanceInitialLoading, debtorBalanceError } = useLoadDebtorBalance(
    debtorId,
    true,
  );

  const debtor = isNullish(debtorDetailsResponse?.data)
    ? null
    : treatClient(debtorDetailsResponse.data);
  const balance = debtorBalance ? computeDebtorBalance(debtorBalance) : null;

  return {
    debtor,
    balance,
    isDebtorReady: !isDebtorLoading && debtor !== null,
    isDebtorBalanceInitialLoading,
    hasDebtorError: isDebtorError,
    hasBalanceError: Boolean(debtorBalanceError),
  };
};
